import { lazyLoad } from 'app/utils/loadable';

export const RepairErrorPage = lazyLoad(
  () => import('./repair-error-page'),
  (module) => module.RepairErrorPage
);
